import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { getUserInfo } from '../lib/api/Auth-Service'
import { useQuery } from '@tanstack/react-query'

const LabWorkspaceContext = createContext()

export const LabWorkspaceProvider = ({ children }) => {
  const { data: userinfo } = useQuery(['userinfo'], getUserInfo)
  const userID = userinfo?.data?.uid

  const [darkMode, setDarkMode] = useState(true)
  const toggleDarkMode = () => {
    setDarkMode(!darkMode)
  }

  const [sidebarState, setSidebarState] = useState({
    home: true,
    instruction: false,
    video: false,
    terminal: false,
    loadBalancer: false,
  })
  const toggleSidebar = (key) => {
    setSidebarState((prevState) => {
      // Create a new object with all values set to false
      const newState = Object.keys(prevState).reduce((acc, currKey) => {
        acc[currKey] = false
        return acc
      }, {})

      // Set the specified key to true
      newState[key] = true

      return newState
    })
  }

  const [duration, setDuration] = useState(0)

  const [loading, setLoading] = useState(false)

  const [numTerminals, setNumTerminals] = useState(1)
  const [currentTerminal, setCurrentTerminal] = useState(1)

  const handleTerminalChange = (terminalNumber) => {
    setCurrentTerminal(terminalNumber)
  }

  const addTerminal = () => {
    setNumTerminals(numTerminals + 1)
    setCurrentTerminal(numTerminals + 1)
  }

  const handleCloseTerminal = () => {
    if (numTerminals > 1) {
      setNumTerminals(numTerminals - 1)
    }
  }
  useEffect(() => {
    handleTerminalChange(numTerminals)
  }, [numTerminals])

  const contextValue = useMemo(
    () => ({
      darkMode,
      userID,
      toggleDarkMode,
      sidebarState,
      toggleSidebar,
      duration,
      setDuration,
      loading,
      setLoading,
      numTerminals,
      currentTerminal,
      handleTerminalChange,
      addTerminal,
      handleCloseTerminal,
    }),
    [darkMode, sidebarState, duration, loading, numTerminals, currentTerminal]
  )

  return (
    <LabWorkspaceContext.Provider value={contextValue}>{children}</LabWorkspaceContext.Provider>
  )
}

export const useLabWorkspace = () => {
  const context = useContext(LabWorkspaceContext)
  if (!context) {
    throw new Error('useLabWorkspace must be used within a LabWorkspaceProvider')
  }
  return context
}
